import React from 'react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {ListItem, OrderedList} from '@chakra-ui/react'
import TermsModal from './TermsModal'

const DirectDebitRequestServiceAgreementModal = ({
  triggerLabel,
  triggerButtonVariant,
}) => {
  const {t} = useTranslation('onboarding')

  return (
    <TermsModal
      triggerButtonVariant={triggerButtonVariant}
      triggerLabel={
        triggerLabel ||
        t(
          'onboarding:ZeptoDirectDebitRequestServiceAgreementModal.triggerLabel',
        )
      }
      modalTitle={t(
        'onboarding:ZeptoDirectDebitRequestServiceAgreementModal.title',
      )}
    >
      <OrderedList spacing="md">
        <ListItem>
          INITIAL TERMS By agreeing to a Direct Debit Request, Zepto will debit
          your nominated account for the amounts and at the frequency of
          payments as agreed between you and the Payment Initiator. Zepto has
          been contracted by the Payment Initiator to collect direct debit
          payments from you and does not provide any goods or services to you.
        </ListItem>
        <ListItem>
          CHANGE OF TERMS The terms of this Agreement or a DDR may be varied at
          any time by giving you at least 30 days’ written notice. This is
          managed through the Zepto Platform.
        </ListItem>
        <ListItem>
          DEFERRING OR STOPPING A PAYMENT Should you wish to defer a payment to
          another date you must contact the Payment Initiator before the date of
          that payment to request the deferment. Deferments are entirely at the
          discretion of the Payment Initiator. You may request to stop an
          individual payment through the Zepto platform however you will still
          be liable to make this payment to the Payment Initiator.
        </ListItem>
        <ListItem>
          ALTERING THE SCHEDULE Should you wish to alter the payment frequency
          or Day to Debit contact the Payment Initiator. Altering schedule is
          solely at the discretion of the Payment Initiator. The Payment
          Initiator may charge a fee for this service. The Payment Initiator
          shall notify you of these fees. Any changes made will not affect the
          total amount you would otherwise have paid over the minimum term of
          your Contract.
        </ListItem>
        <ListItem>
          CANCELLING THE PAYMENTS You can cancel this Direct Debit Request
          Authority at any time by contacting the Payment Initiator or Zepto.
          Cancellation of the authority to debit your account will not terminate
          your contract or remove your liability to make the payments you have
          agreed to with the Payment Initiator.
        </ListItem>
        <ListItem>
          LIABILITY If you stop or cancel either a DDR or an individual debit
          payment as a result of a variation to the terms of this Direct Debit
          Service Agreement or a DDR by Zepto or the Payment Initiator, no
          penalty will be imposed on you.
        </ListItem>
        <ListItem>
          DISPUTES If you dispute any debit payment, you must notify the Payment
          Initiator immediately. The Payment Initiator will respond to your
          dispute within 7 working days and will immediately refund the amount
          of the debit if they are not able to substantiate the reason for it.
          If you do not receive a satisfactory response from the Payment
          Initiator to your dispute, contact Zepto who will respond to you with
          an answer to your claim within 5 business days if your claim is lodged
          within 12 months of the disputed drawing, or within 30 business days
          if your claim is lodged after 12 months from the disputed drawing.
        </ListItem>
        <ListItem>
          BUSINESS DAYS When the day to debit falls on a weekend or public
          holiday the debit will be initiated on the next business day.
        </ListItem>
        <ListItem>
          DISHONOURED PAYMENTS It is your responsibility to ensure that on the
          due date clear funds are available in your nominated account to meet
          the direct debit payment. Should your payment be dishonoured, you
          authorise Zepto to debit your account when clear funds become
          available in your nominated bank account.
        </ListItem>
        <ListItem>
          ENQUIRIES Please direct enquiries to support@zepto.com.au. PRIVACY
          Zepto will keep information relating to your nominated account
          confidential in accordance with Zepto’s Privacy Policy, available at
          zepto.com.au/privacy.
        </ListItem>
        <ListItem>
          YOUR OTHER RESPONSIBILITIES In addition to those already mentioned,
          you are responsible for ensuring that your nominated account is able
          to accept direct debits. If it is not, it is your responsibility to
          provide Zepto with a new account number.
        </ListItem>
      </OrderedList>
    </TermsModal>
  )
}

DirectDebitRequestServiceAgreementModal.defaultProps = {
  triggerLabel: undefined,
  triggerButtonVariant: 'primary',
}

DirectDebitRequestServiceAgreementModal.propTypes = {
  triggerLabel: PropTypes.string,
  triggerButtonVariant: PropTypes.string,
}

export default DirectDebitRequestServiceAgreementModal
